import joinUrl from "../../utils/join-url";
import requestUtility from "../../helpers/request-utility";

const setBillingProfileAsDefault = (apiUrl) => (id) => {
  const url = joinUrl(
    apiUrl,
    `/checkoutservice/pb/billing-profiles/${id}/set-as-default/`
  );
  return requestUtility.post(url);
};

export default setBillingProfileAsDefault;
